import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, Typography, FormControlLabel, Switch, Autocomplete, FormControl, IconButton} from "@mui/material";
import { ModalBox } from '../../../styles/ModalStyles';
import { getClienteHabilitado } from '../../http/actions/ClientesAction';
import CloseIcon from '@mui/icons-material/Close';
const EditarCorreoModal = ({ open, onClose, onSubmit, correo }) => {
  const [nombreDestinatario, setNombreDestinatario] = useState('');
  const [correoDestinatario, setCorreoDestinatario] = useState('');
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    fetchClientes();
  }, []);

  useEffect(() => {
    if (correo) {
      setNombreDestinatario(correo.nombreDestinatario);
      setCorreoDestinatario(correo.correoDestinatario);
      setHabilitado(correo.habilitado);

      const clienteCorrespondiente = clientes.find(c => c.id === correo.clienteId);
      setClienteSeleccionado(clienteCorrespondiente || null);
    }
  }, [correo, clientes]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...correo,
      nombreDestinatario,
      correoDestinatario,
      clienteId: clienteSeleccionado ? clienteSeleccionado.id : null,
      habilitado
    });
    onClose();
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant='h6'>Editar correo de Tramitación</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre destinatario"
            value={nombreDestinatario}
            onChange={(e) => setNombreDestinatario(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Correo destinatario"
            value={correoDestinatario}
            onChange={(e) => setCorreoDestinatario(e.target.value)}
            margin="normal"
            required
          />
          <FormControl fullWidth sx={{mt: 2}}>
          <Autocomplete
            noOptionsText="No hay opciones disponibles"
            options={clientes}
            getOptionLabel={(option) => option.nombre || ''} // Asume que cada cliente tiene una propiedad 'nombre'
            renderInput={(params) => <TextField {...params} label="Cliente" />}
            value={clienteSeleccionado}
            onChange={(event, newValue) => {
              setClienteSeleccionado(newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={habilitado}
                onChange={(e) => setHabilitado(e.target.checked)}
                color="primary"
              />
            }
            label={habilitado ? "Habilitado" : "Deshabilitado"}
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }}>
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarCorreoModal;